import React from "react";

const B2b = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="32"
      viewBox="0 0 52 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_604" transform="translate(-1295.001 -381)">
        <g id="Raggruppa_477" transform="translate(953.059 -60.397)">
          <path
            id="Tracciato_114"
            d="M4.331,0H45.669C48.061,0,50,2.245,50,5.015v19.97C50,27.755,48.061,30,45.669,30H4.331C1.939,30,0,27.755,0,24.985V5.015C0,2.245,1.939,0,4.331,0Z"
            transform="translate(342.942 442.397)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <text
            id="B2B"
            transform="translate(351.44 463.897)"
            fontSize="16"
            fontWeight="400"
            fontStyle="italic"
            letterSpacing="0.04em"
          >
            <tspan x="0" y="0">
              B2B
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default B2b;
